import { BaseService } from "./base.service";
export class ProgramDivisionService extends BaseService {
  constructor() {
    super("program-divisions");
  }
}
